import React from 'react';
import EmptyState from '../components/EmptyState';

const DevProductDevPage = () => {
  return (
    <div className="flex flex-col gap-6 p-6">
      <header>
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-50">
          Product Development
        </h1>
        <p className="text-sm text-slate-500">Product development, submissions, and audits</p>
      </header>
      <EmptyState message="Product Development page - Coming soon" />
    </div>
  );
};

export default DevProductDevPage;
